import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { Picture } from 'react-imgix';
import PropTypes from 'prop-types';
const JBResponsiveImage = t0 => {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <img src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" className="hidden h-0 w-0" alt="" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <Picture>{children}{t1}</Picture>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
JBResponsiveImage.propTypes = {
  children: PropTypes.node
};
export default JBResponsiveImage;